<template>
    <div>
        <el-drawer :visible.sync="drawer" size="60%">
          <div>
            <BjPage ref="BjPage" :query-params="queryParams" :get-action="queryApi" :search-btn-hide="true" :serial="serial" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
              <template v-slot:tableOperation>
                  <el-col>
                      <el-button type="primary" class="main-btn" @click="onAdd()">{{$t('addText')}}</el-button>
                  </el-col>
              </template>
              <template v-slot:tableColumn>
                <template v-for="(col, index) in dropCols">
                  <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
                    <template slot-scope="scope">
                      <template v-if="false" />
                      <template v-else-if="col.prop === 'logisticsName'">
                          <span class="link" @click="openInside(scope.row)">{{ scope.row[col.prop]}}</span>
                      </template>
                      <template v-else-if="col.prop === 'profitMargin'">
                          <span>{{ scope.row[col.prop]}} %</span>
                      </template>
                      <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
                    <template slot-scope="props">
                        <el-button type="text" size="small" @click="outsideFormCopy(props.row)">{{ $t('copyText') }}</el-button>
                        <el-button type="text" size="small" @click="outsideFormDel(props.row)">{{ $t('delText') }}</el-button>
                    </template>
                  </el-table-column>
                </template>
              </template>
             </BjPage>
            <!-- 侧边栏 / 二级侧边栏 -->
            <InsideDrawer ref="InsideDrawer" @openInsideDialog="openInsideDialog" @homeReFresh="homeReFresh"/>
          </div>
        </el-drawer>
        <!-- 一级侧边栏 ==> 弹出框 -->
        <el-dialog :visible.sync="dialogVisibleTwo" width="500px" :before-close="handleClose2">
          <el-form ref="form2" :model="form2" status-icon :rules="rules2" label-position="top" label-width="100px">
            <el-form-item :label="$t('WarehouseManagement.form.chooseLogistics')" prop="logisticsName">
              <!-- <BjInput v-model="form2.logisticsName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('WarehouseManagement.form.chooseLogistics')" clearable @keyup.enter.native="handleQuery" /> -->
              <BjSelectLov v-model="form2.logisticsName" :option-list="LogisticsList" :placeholder="$t('LogisticsRulesTable.header.Logistics')" clearable/>
             </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose2">{{ $t('cancelText') }}</el-button>
            <el-button type="primary" @click="onConfirm2()">{{ $t('okText') }}</el-button>
          </span>
        </el-dialog>
        <!-- 二级侧边栏 ==> 弹出框 -->
        <el-dialog :visible.sync="dialogVisibleThree" width="500px" :before-close="handleClose3">
          <el-form ref="form3" :model="form3" status-icon :rules="rules3" label-position="top" label-width="100px">
            <el-form-item :label="$t('billingPage.zoneGroup')" prop="logisticsGroupName" v-if="!form3.id">
              <BjSelectLov v-model="form3.logisticsGroupName" :option-list="logisticsGroupList" :placeholder="$t('billingPage.zoneGroup')" @change="getName"/>
            </el-form-item>
            <el-form-item :label="$t('businessLogisticsCompanyBusiness.table.ProfitMargin')" prop="profitMargin">
              <BjInputMoney v-model="form3.profitMargin" :placeholder="$t('businessLogisticsCompanyBusiness.table.ProfitMargin')" clearable><template slot="append">%</template></BjInputMoney>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose3">{{ $t('cancelText') }}</el-button>
            <el-button type="primary" @click="onConfirm3()">{{ $t('okText') }}</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
import pageMiXin from '@/utils/page-mixin.js';
import InsideDrawer from './InsideDrawer.vue';
import { logisticApi } from '@/api';
export default {
    components: {
        InsideDrawer,
    },
    mixins: [pageMiXin],
    data() {
        return {
            colSpan: 4,
            drawer: false,
            innerDrawer: false,
            queryApi: logisticApi.getLogisticName,
            queryParams:{
                customerConfigId:null,
            },
            labelList: [
                {label: this.$t('WarehouseManagement.form.chooseLogistics'),prop: 'logisticsName',isCheck: true,disabled: false,},
                {label: this.$t('WarehouseManagement.form.DefaultMargin'),prop: 'profitMargin',isCheck: true,disabled: false,},
                {label: this.$t('table.operationText'),prop: 'bjTableAction',isCheck: true,disabled: false,width: 160,},
            ],
            // 物流下拉框数据
            LogisticsList:[],
            // 一级侧边栏弹窗
            dialogVisibleTwo:false,
            form2:{
                logisticsName:null,
            },
            // 二级侧边栏弹窗
            dialogVisibleThree:false,
            form3:{
                id:null,
                logisticsGroupName:null,
                GroupName:null,
                profitMargin:null,
            },
            // 二级侧边栏新增内 下拉框数据
            logisticsGroupList:[],
        };
    },
    computed: {
      rules2() {
        const rules = {
            logisticsName: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        };
        return rules;
      },
      rules3() {
        const validateRate = (rule, value, callback) =>{
          if (!value) {
            callback(new Error(this.$t('inputText')));
          }
          if(value<=0 || value>=100){
            callback(new Error(this.$t('businessLogisticsCompanyBusiness.table.errTip')));
          }
          callback();
        }
        const rules = {
            logisticsGroupName: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
            profitMargin: [{ required: true, validator: validateRate, trigger: 'blur' }],
        };
        return rules;
      },
    },
    created(){
        this.getGroupList()
        // 获取物流下拉信息
        this.getLogisticsDataList();
    },
    methods: {
        // 获取物流下拉信息
        async getLogisticsDataList() {
          logisticApi.getLogisticsBusiness({
              currentPage: 0,
              page: 0,
              pagesize: 999,
              size: 999,
            }).then(res => {
            this.LogisticsList = res.content.map(item => {
              return {
                label: item.name,
                value: item.name
              };
            });
          });
        },
        // 新增
        onAdd(){
            this.dialogVisibleTwo = true
        },
        // 保存弹窗
        onConfirm2(){
          this.$refs.form2.validate((valid) => {
            if(valid){
                if(this.form2.id){
                    // 复制
                    const POST_DATA = {
                        id:this.form2.id,
                        customerConfigId:this.form2.customerConfigId,
                        logisticsName:this.form2.logisticsName,
                    }
                    logisticApi.copyLogisticName(POST_DATA).then(res=>{
                      if(!res.failed){
                        this.$message.success(this.$t('toast.operationSuccessText'));
                        setTimeout(() => {
                          this.handleClose2()
                          this.homeReFresh();
                          this.reFresh();
                        }, 500);
                      }
                    })
                }else{
                    // 新增
                    const POST_DATA = {
                      customerConfigId:this.queryParams.customerConfigId,
                      logisticsName:this.form2.logisticsName,
                    }
                    logisticApi.addLogisticName(POST_DATA).then(res=>{
                      if(!res.failed){
                        this.$message.success(this.$t('toast.operationSuccessText'));
                        setTimeout(() => {
                          this.handleClose2()
                          this.homeReFresh();
                          this.reFresh();
                        }, 500);
                      }
                    })
                }
            }
          })
        },
        // 关闭弹窗
        handleClose2(){
            this.form2 = { logisticsName:null,}
            this.$refs['form2'].resetFields();
            this.dialogVisibleTwo = false
        },
        // 复制
        outsideFormCopy(row){
            this.dialogVisibleTwo = true
            this.form2 = JSON.parse(JSON.stringify(row))
        },
        // 删除
        outsideFormDel(row){
            this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
              confirmButtonText: this.$t('toast.okText'),
              cancelButtonText: this.$t('toast.cancelText'),
              type: 'warning',
            }).then(() => {
              logisticApi.delLogisticName({ids: [row.id]}).then(res => {
                if(!res.failed){
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  this.homeReFresh();
                  this.reFresh();
                }
              });
            })
        },
        // 获取二级侧边栏新增内 下拉框数据
        getGroupList(){
            logisticApi.getLogisticGroupdict().then(res=>{
                console.log(res,'res');
                this.logisticsGroupList = res.map(item => {
                    return { label: item.logisticsGroupName, value: item.id, name:item.logisticsGroupName };
                });
            })
        },
        // 打开二级侧边栏
        openInside(row){
            this.$refs.InsideDrawer.queryParams.logisticsNameId = row.id
            this.$refs.InsideDrawer.drawer = true
            this.$refs.InsideDrawer.reFresh()
        },
        // 二级侧边栏穿出来的方法
        openInsideDialog(row){
          if(row?.id){
            this.form3 = JSON.parse(JSON.stringify(row))
            this.dialogVisibleThree = true
          }else{
            this.dialogVisibleThree = true
          }
        },
        getName(n,m){
          this.form3.GroupName = m.name
        },
        onConfirm3(){
          this.$refs.form3.validate((valid) => {
            if(valid){
              if(!this.form3.profitMargin || this.form3.profitMargin=="NaN") return this.$message.error(this.$t('businessLogisticsCompanyBusiness.table.ProfitMargin')+' '+this.$t('formatErrorText'));
              const POST_DATA = {
                logisticsNameId:this.$refs.InsideDrawer.queryParams.logisticsNameId,
                logisticsGroupId:this.form3.logisticsGroupName,
                logisticsGroupName:this.form3.GroupName,
                profitMargin:this.form3.profitMargin,
                rate : (1/(1 - this.form3.profitMargin/100)).toFixed(2)
              }
              if(this.form3.id){
                logisticApi.editLogisticGroup({...this.form3,rate:(1/(1 - this.form3.profitMargin/100)).toFixed(2)}).then(res=>{
                  if(!res.failed){
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    setTimeout(() => {
                      this.handleClose3()
                      this.$refs.InsideDrawer.reFresh();
                      this.homeReFresh();
                      this.$emit('reFresh');
                    }, 500);
                  }
                })
              }else{
                logisticApi.addLogisticGroup(POST_DATA).then(res=>{
                  if(!res.failed){
                    this.$message.success(this.$t('toast.operationSuccessText'));
                    setTimeout(() => {
                      this.handleClose3()
                      this.$refs.InsideDrawer.reFresh();
                      this.homeReFresh();
                      this.$emit('reFresh');
                    }, 500);
                  }
                })
              }
            }
          })
        },
        handleClose3(){
            this.form3 = {
                id:null,
                logisticsGroupName:null,
                GroupName:null,
                profitMargin:null,
              }
            this.$refs['form3'].resetFields();
            this.dialogVisibleThree = false
        },
        homeReFresh() {
          this.$emit('reFresh');
        },
    },
};
</script>

<style lang="scss" scoped>
  ::v-deep .el-drawer__body {
    overflow: auto;
    padding: 16px;
  }
</style>